module.exports = __webpack_public_path__ + "img/Spanish.5629c5eb.svg";